import { readAssignmentIdsByGroupId, readAssignmentFromStore } from '../group-store'
function getAssignmentsFromGroupId(groupId) {
  const assignmentIds = readAssignmentIdsByGroupId(groupId) ?? []
  return assignmentIds.map(readAssignmentFromStore)
}

export { getAssignmentsFromGroupId }